import React, { Component, PropTypes } from 'react';

import { dayInMilliseconds } from 'utils/utils';
import dates from 'utils/dates';

import './MonthCalendar.scss';

export default class MonthCalendar extends Component {
  static propTypes = {
    numberOfMonths: PropTypes.number,
    onSelectMonth: PropTypes.func.isRequired,
  };

  static defaultProps = {
    numberOfMonths: 15,
  };

  handleMonthClick = (event) => {
    event.preventDefault();

    const value = event.currentTarget.dataset.value;
    this.props.onSelectMonth(value);
  };

  getMonthsCollection(date = dates.utcDate()) {
    const { numberOfMonths } = this.props;

    date.setDate(1);
    const monthsCollection = [];

    for (let i = 0; i < numberOfMonths; i++) {
      const timestamp = Date.UTC(date.getFullYear(), date.getMonth() + i, 1);
      const calDate = timestamp / dayInMilliseconds;
      const monthAndYearText = dates.format(timestamp, 'MMM YYYY');

      monthsCollection.push({
        name: monthAndYearText,
        value: `${calDate}`,
      });
    }

    return monthsCollection;
  }

  render() {
    const months = this.getMonthsCollection();

    return (
      <div className="month-calendar">
        <div className="month-calendar__months">
          {
            months.map(({ name, value }) => (
              <div key={value} className="month-calendar__month">
                <button className="month-calendar__month-button" data-value={value} onClick={this.handleMonthClick}>{name}</button>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/MonthCalendar/MonthCalendar.jsx
 **/